!function() {

// Breakpoints
bp1 = 1235;
bp2 = 1055;
bp3 = 855;
bp4 = 760;
bp5 = 600;
bpFxs = 560;
bp6 = 500;
bp7 = 420;

var headerHeight;

function onReady(cb) {
  if (document.readyState == 'complete') {
    setTimeout(ready);
  }

  document.addEventListener('DOMContentLoaded', ready);
  window.addEventListener('load', ready);

  function ready() {
    document.removeEventListener('DOMContentLoaded', ready);
    window.removeEventListener('load', ready);
    cb();
  }
}

function onLoad(cb) {
  window.addEventListener('load', function inner() {
    window.removeEventListener('load', inner);
    cb();
  });
}

function onPopupClose(cb) {
  onLoad(function() {
    var $tos = $(".js--agree-to-tcs");

    // If we have a popup we need to wait for it to close.
    if ($tos.length) {
      $tos.on("click", function() {
        cb();
      });
    }
    // Otherwise we're firing off asap.
    else {
      setTimeout(cb);
    }
  });
}

// Show a tab
function showTab($btn) {
  var $item;
  if (!$btn.parent().hasClass("highlight")) {
    $item = $btn.parent();
  } else {
    $item = $(
      '.tabs-list__item button[data-target="' +
        $btn.attr("data-target") +
        '"]'
    ).parent();
  }

  var $tabsList = $(".tabs-list");

  // First tab class
  if ($item.is(":first-child")) {
    $("html").addClass("tabs-first-item");
  } else {
    $("html").removeClass("tabs-first-item");
  }

  // Set tab button as active
  $tabsList.find(".tabs-list__item").removeClass("tabs-list__item--active");
  $item.addClass("tabs-list__item--active");

  // Set tab content as active
  var $target = $('.tab[data-tab="' + $btn.attr("data-target") + '"]');
  $target.siblings(".tab").removeClass("tab--active");
  $target.addClass("tab--active");

  // Trigger resize for parallax update3
  if ($(window).width() > bp2) {
    $(window).trigger("resize").trigger("scroll");
  }

  // Scroll to top if mobile
  if ($(window).width() <= bp5) {
    window.scrollTo(0, 0);
  }

  // Add index
  $tabsList.attr("data-active-index", $item.index() + 1);
}

// Show the tab specified by the URL, or the first tab if nothing specified (this shouldn't ever happen)
function showDefaultTab() {
  var $def = $btns.filter(
    '[data-target="' + window.location.hash.substring(1) + '"]'
  );
  if ($def.length) {
    showTab($def);
  } else {
    showTab($btns.filter(":first"));
  }
}

// Article boxes
// Hover states
function articleBoxShow(e) {
  $(e.delegateTarget)
    .addClass("article-box__list__item--hover")
    .find(".article-box__content__hover")
    .stop()
    .slideDown(300);
}

function articleBoxHide(e) {
  $(e.delegateTarget)
    .removeClass("article-box__list__item--hover")
    .find(".article-box__content__hover")
    .stop()
    .slideUp(250);
}

function checkArticleBoxHover() {
  if ($(window).width() > bp2) {
    $(".article-box__list--hover-states .article-box__list__item")
      .off("mouseenter", articleBoxShow)
      .on("mouseenter", articleBoxShow);
    $(".article-box__list--hover-states .article-box__list__item")
      .off("mouseleave", articleBoxHide)
      .on("mouseleave", articleBoxHide);
  } else {
    $(".article-box__list--hover-states .article-box__list__item").off(
      "mouseenter",
      articleBoxShow
    );
    $(".article-box__list--hover-states .article-box__list__item").off(
      "mouseleave",
      articleBoxHide
    );
  }
}

// Feature tile sliders
// Hover states
function featureTileShow(tileItem) {
  var $this = tileItem;
  if (tileItem.hasOwnProperty("delegateTarget")) {
    $this = $(tileItem.delegateTarget);
  } else {
    $this = $(tileItem);
  }
  $this
    .addClass("feature-tile-hover")
    .find(".feature-tile-content__hover")
    .stop()
    .slideDown(300);
}

function featureTileHide(tileItem) {
  var $this = tileItem;
  if (tileItem.hasOwnProperty("delegateTarget")) {
    $this = $(tileItem.delegateTarget);
  } else {
    $this = $(tileItem);
  }
  $this
    .removeClass("feature-tile-hover")
    .find(".feature-tile-content__hover")
    .stop()
    .slideUp(250);
}

/* note: There are two functions both called checkFeatureTileHover
 * I did some test on the homepage and search results page and this one doesn't seem to be fired
 * Commented out in July 2023 and if nothing breaks, let's remove it.
 * function checkFeatureTileHover() {
 *   if ($(window).width() > bp2 && getDiscreetMode() != "y") {
 *     $(".feature-tile")
 *       .off("mouseenter", featureTileShow)
 *       .on("mouseenter", featureTileShow);
 *     $(".feature-tile")
 *       .off("mouseleave", featureTileHide)
 *       .on("mouseleave", featureTileHide);
 *   } else {
 *     $(".feature-tile").off("mouseenter", featureTileShow);
 *     $(".feature-tile").off("mouseleave", featureTileHide);
 *     $(".feature-tile-content__hover").css({
 *       display: "",
 *       height: "",
 *       paddingTop: "",
 *       marginTop: "",
 *       paddingBottom: "",
 *       marginBottom: "",
 *     });
 *   }
 * }
 */

function toggleFeatureTileHover() {
  if (getDiscreetMode() == "y") {
    $(".feature-tile").each(function () {
      featureTileShow($(this));
    });

    // disable hover
    $(".feature-tile").off("mouseenter");
    $(".feature-tile").off("mouseleave");
  } else {
    $(".feature-tile").each(function () {
      featureTileHide($(this));
    });
    // enable hover
    $(".feature-tile").on("mouseenter", featureTileShow);
    $(".feature-tile").on("mouseleave", featureTileHide);
  }
}

/* -----------------------------
    Discreet mode
-------------------------------- */
function getDiscreetMode() {
  var isDiscreetMode = localStorage.getItem("discreetMode");
  return isDiscreetMode;
}

function setDiscreetMode(val) {
  localStorage.setItem("discreetMode", val);
}

function activateDiscreetMode() {
  $("html").addClass("discreet-mode-on");
  setDiscreetMode("y");
  toggleFeatureTileHover();
}

function deactivateDiscreetMode() {
  $("html").removeClass("discreet-mode-on");
  setDiscreetMode("n");
  toggleFeatureTileHover();
}


onLoad(function() {
   // FrankenMenu
   if(jQuery().frankenMenu) {
    $("#frankenmenu").frankenMenu({
      menuBreakpoint: 160,
      desktopHoverDelay: window.innerWidth >= 576 ? 600 : 200,
    });
  }
});

onReady(function() {
  // Passive event listeners
  jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchstart", handle, {
        passive: !ns.includes("noPreventDefault"),
      });
    },
  };
  jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchmove", handle, {
        passive: !ns.includes("noPreventDefault"),
      });
    },
  };

  const $window = $(window);
  const $html = $("html");

  headerHeight =
    $("#header").height() + parseInt($("#header").css("padding-top")) * 2;


  // Select placeholder effect
  $("option.dropdown-top:selected")
    .closest(".field-element")
    .addClass("field-element--select--placeholder");
  $(".field-element--select--placeholder select").change(function () {
    var placeholderSelected = $("option:selected", this).hasClass(
      "dropdown-top"
    );
    if (!placeholderSelected) {
      $(this)
        .closest(".field-element")
        .removeClass("field-element--select--placeholder");
    } else if (placeholderSelected) {
      $(this)
        .closest(".field-element")
        .addClass("field-element--select--placeholder");
    }
  });

  /* -----------------------------
	   Header scroll
	-------------------------------- */
  var headerScrolled = false;
  var headerInitialOffset = $('#header').offset().top;

  function checkScrolledHeader() {
    if (headerScrolled === false && $window.scrollTop() > headerInitialOffset) {
      $html.addClass("header-sticky");
      headerScrolled = true;
    } else if (headerScrolled === true && $window.scrollTop() <= headerInitialOffset) {
      $html.removeClass("header-sticky");
      headerScrolled = false;
    }
  }

  /* -----------------------------
	   Sticky search bar
	-------------------------------- */
  var stickySearch = false;
  var stickyTabs = false;
  var initialSearchOffset;
  var searchHeight = $(".js--search-bar").outerHeight();
  var tabsHeight = $(".js--tabs-anchor").outerHeight();

  // For sticky search
  if ($(".js--search-bar").length > 0) {
    initialSearchOffset = $(".js--search-bar").offset().top - headerHeight;
  }

  function checkStickySearch() {
    if ($window.width() < bpFxs) {
      if (
        $window.scrollTop() >= initialSearchOffset + searchHeight &&
        !stickySearch
      ) {
        $html.addClass("sticky-search");
        stickySearch = true;
      } else if (
        $window.scrollTop() < initialSearchOffset + searchHeight &&
        stickySearch
      ) {
        $html.removeClass("sticky-search");
        stickySearch = false;
      }
    } else {
      if ($window.scrollTop() >= initialSearchOffset && !stickySearch) {
        $html.addClass("sticky-search");
        stickySearch = true;
      } else if ($window.scrollTop() < initialSearchOffset && stickySearch) {
        $html.removeClass("sticky-search");
        stickySearch = false;
      }
    }
  }

  // For sticky search
  if ($(".js--tabs-anchor").length > 0) {
    initialTabsOffset = $(".js--tabs-anchor").offset().top - headerHeight;
  }

  function checkStickyTabs() {
    if ($window.width() < bpFxs) {
      if (
        $window.scrollTop() >= initialTabsOffset + tabsHeight &&
        !stickyTabs
      ) {
        $html.addClass("tabs-sticky");
        stickyTabs = true;
      } else if (
        $window.scrollTop() < initialTabsOffset + tabsHeight &&
        stickyTabs
      ) {
        $html.removeClass("tabs-sticky");
        stickyTabs = false;
      }
    } else {
      if ($window.scrollTop() >= initialTabsOffset && !stickyTabs) {
        $html.addClass("tabs-sticky");
        stickyTabs = true;
      } else if ($window.scrollTop() < initialTabsOffset && stickyTabs) {
        $html.removeClass("tabs-sticky");
        stickyTabs = false;
      }
    }
  }

  $window.on("scroll resize", function () {
    checkScrolledHeader();
    checkStickySearch();

    if($('html').hasClass('header-sticky') == false && $('.js-header-search').length > 0) {
      $('.js-header-search').css('top', (($('#header').outerHeight() + $('.js-cities-list').outerHeight()) - $(this).scrollTop()) + 'px');
    } else {
      $('.js-header-search').attr('style', '');
    }

    if ($(".js--tabs-anchor").length > 0) {
      checkStickyTabs();
    }
  });


  checkScrolledHeader();
  checkStickySearch();

  if ($(".js--tabs-anchor").length > 0) {
    checkStickyTabs();
  }

  // Header search button
  var searchDropdown = false;

  $(".js-header-search-button, .js--mobile-search-jump").click(function () {
    var $this = $(this);

    // If on home page focus existing search bar
    if ($this.hasClass("header-search-button--no-dropdown")) {
      $firstSearchBarItem = $(
        ".search-bar .field-element--state select"
      );

      headerHeight = $("#header").outerHeight();

      var scrollAmount = $firstSearchBarItem.offset().top - headerHeight - 140;

      $("html, body").animate(
        {
          scrollTop: scrollAmount,
        },
        500,
        function () {
          $firstSearchBarItem.focus().addClass("highlight-pulse");
          setTimeout(function () {
            $firstSearchBarItem.removeClass("highlight-pulse");
          }, 1000);
        }
      );
    }
    // Else display a search bar
    else if ($this.hasClass("header-search-button--dropdown")) {
      function openSearchDropdown() {
        $("html").addClass("header-search-dropdown");
        $("body").on("click touchend", checkSearchBoundary);
        searchDropdown = true;

        $(".search-bar .field-element--state select").focus();
      }

      function closeSearchDropdown() {
        $("html").removeClass("header-search-dropdown");
        $("body").off("click touchend", checkSearchBoundary);
        searchDropdown = false;

        $(".search-bar .field-element--state select").blur();
      }

      function checkSearchBoundary(e) {
        if (
          !$(e.target).is(".js-header-search-button") &&
          !$(e.target).is(".js-header-search-button svg") &&
          !$(e.target).is(".js-header-search-button span") &&
          !$(e.target).is(".js-header-search-button path") &&
          !$(e.target).is(".header-search") &&
          !$(e.target).parents(".header-search").length
        ) {
          closeSearchDropdown();
        }
      }

      if (!searchDropdown) {
        openSearchDropdown();
      } else {
        closeSearchDropdown();
      }
    }
  });

  // Tabs
  var $btns = []; //$('.js--tab-list-button');

  // Click on a tab to set a history item and show the tab
  // $btns.click(function(){
  // 	var $this = $(this);
  // 	showTab($this);

  // 	// Don't change pushState until tab transition is finished. Otherwise transition jumps in chrome
  // 	window.setTimeout(function() {
  // 		var state = {
  // 			tab: $this.attr("data-target")
  // 		};
  // 		var url = window.location.origin + window.location.pathname +'#'+state.tab;
  // 		history.pushState(state, "", url);
  // 	}, 200);

  // });

  // History pop event - back or forward button pressed
  $(window).bind("popstate", function (event) {
    var state = event.originalEvent.state;
    if (state === null) {
      showDefaultTab();
    } else {
      var $tab = $btns.filter('[data-target="' + state.tab + '"]');
      showTab($tab);
    }
  });

  // Set discreet mode
  if (
    localStorage.getItem("discreetMode") != "n" &&
    localStorage.getItem("discreetMode") != "y"
  ) {
    setDiscreetMode("n");
  } else if (getDiscreetMode() == "y") {
    activateDiscreetMode();
  }

  // Discreet mode toggle button
  $(document).on("click", ".js--discreet-mode", function () {
    if (getDiscreetMode() == "n") {
      activateDiscreetMode();
    } else if (getDiscreetMode() == "y") {
      deactivateDiscreetMode();
    } else {
      setDiscreetMode("n");
    }
  });

  $(document).on("click", ".js--scroll-to", function (e) {
    e.preventDefault();
    var target = $(this).attr("data-target");
    var $elem = $(target);
    var offsetAdj = $(this).attr("data-offset-adj");
    scrollUp($elem, 500, offsetAdj);
  });

  let advancedFiltersVis = false;

  $(document).on("click", ".js--filter-toggle", function () {
    let $this = $(this);

    if (advancedFiltersVis == false) {
      $(".js--filters").removeClass("hidden");
      $this.find("span").replaceWith("<span>Close</span>");
      advancedFiltersVis = true;
    } else {
      $(".js--filters").addClass("hidden");
      $this.find("span").replaceWith("<span>See more</span>");
      advancedFiltersVis = false;
    }
  });
});

onLoad(function() {
  // Feature tile sliders
  // Hover states

  checkArticleBoxHover();
  $(window).on("resize", checkArticleBoxHover);

  checkFeatureTileHover();
  $(window).on("resize", checkFeatureTileHover);

});

onPopupClose(function() {
    const profileLandscapeSlider = document.querySelector('.js--img-profile-landscape');

    if(!!profileLandscapeSlider) {
      // Landscape profile slider
      var splideLandscapeProfile = new Splide(profileLandscapeSlider, {
        type: 'loop',
        pagination: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 7000,
        lazyLoad: 'nearby',
        perPage: 2,
        perMove: 1,
        preload: 3,
        breakpoints: {
          600: {
            perPage: 1,
          },
        },
    });

    splideLandscapeProfile.mount();
  }

  const profilePortraitSlider = document.querySelector('.js--img-profile-portrait');

  if(!!profilePortraitSlider) {
    // Portrait profile slider
    var splidePortraitProfile = new Splide( '.js--img-profile-portrait', {
      type: 'loop',
      pagination: false,
      arrows: true,
      lazyLoad: 'nearby',
      preload: 2,
    });

    splidePortraitProfile.mount();
  }
});

/* --------------------------------------
    MagnificPopup links
-------------------------------------- */
onReady(function() {
  if (!$.magnificPopup) return;

  $("a.js-popup-page").magnificPopup({
    type: "ajax",
  });

  $("a.js-popup-image, a.js--popup-image").magnificPopup({
    type: "image",
    removalDelay: 300,
    mainClass: "mfp-fade",
  });

  $(".js--popup-inline").magnificPopup({
    type: "inline",
    removalDelay: 300,
    mainClass: "mfp-fade white-popup--ajax",
  });

  $(".js--popup-inline-vid").magnificPopup({
    type: "inline",
    removalDelay: 300,
    mainClass: "mfp-fade white-popup--large white-popup--ajax",
  });

  // additional magnific close button class
  $(document).on("click", ".js--mfp-close", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  // Ajax magnific popup, with "live" event handling
  $(document).on("click", ".magnific-popup--ajax", function (e) {
    var url = $(this).attr("href");
    $.magnificPopup.open({
      items: {
        src: url,
      },
      type: "ajax",
      removalDelay: 300,
      mainClass: "mfp-fade white-popup--ajax",
    });
    e.preventDefault();
  });

  $(document).on("click", ".js--popup-inline", function (e) {
    var id = $(this).attr("href");

    $.magnificPopup.open({
      items: {
        src: id,
        type: "inline",
      },
    });

    e.preventDefault();
  });
});

onLoad(function() {
  // Touch gesture toggle for tile description
  $(document).on("click", ".js--toggle-tile-desc", function () {
    let $this = $(this);
    let currentTileDesc = $(this)
      .closest(".feature-tile-content")
      .find(".feature-tile-content__description");

    if (currentTileDesc.hasClass("expanded")) {
      currentTileDesc.removeClass("expanded");
      $this.find("span").replaceWith("<span>More</span>");
    } else {
      currentTileDesc.addClass("expanded");
      $this.find("span").replaceWith("<span>Less</span>");
    }
  });

  // Social switcher
  $(document).on('click', ".social-switcher .social-icons__item button", function () {
    $(this)
      .closest(".social-switcher__switches__list")
      .find(".social-icons__item")
      .removeClass("social-icons__item--active");
    $(this)
      .closest(".social-icons__item")
      .addClass("social-icons__item--active");
    target = $(this).attr("data-target");

    $(this)
      .closest(".social-switcher")
      .find(".social-post__item")
      .removeClass("social-post__item--active");
    $(".social-post__item__" + target).addClass("social-post__item--active");
  });

  $(window).scroll(function () {
    var wScroll = $(this).scrollTop();
    var hasInitialPopupBeenSeen = localStorage.getItem(
      "imgsystemPopupDismissed"
    );

    // Show popup on scroll
    if (
      $(".js--initial-popup-trigger").length > 0 &&
      hasInitialPopupBeenSeen != "y" &&
      wScroll >
        $(".js--initial-popup-trigger").offset().top - $(window).height() / 3 &&
      $(".gallery-uploader__item__image").length > 0 &&
      jQuery().mangificPopup
    ) {
      $.magnificPopup.open({
        items: {
          src: "#js--imgsystem",
        },
        callbacks: {
          close: function () {
            storeClosed();
          },
        },
        type: "inline",
        removalDelay: 300,
        mainClass: "mfp-fade white-popup--ajax",
      });
    }
  });

  function storeClosed() {
    localStorage.setItem("imgsystemPopupDismissed", "y");
  }

  /* --------------------------------------
		Slide toggle for selfie gallery
	-------------------------------------- */
  var selfiesOpen = false;

  $(document).on("click", ".js--trigger-selfie-slide", function () {
    if (selfiesOpen) {
      $(".js--selfie-slide").slideUp();
      $(".js--trigger-selfie-slide span").text("View");
      selfiesOpen = false;
    } else {
      $(".js--selfie-slide").slideDown();
      $(".js--trigger-selfie-slide span").text("Hide");
      selfiesOpen = true;
    }
  });

  // back button
  $(document).on("click", ".js--back-btn", function () {
    window.history.back();
  });
});

onLoad(function() {
  // Studio and Escort inner search page

  // On load set the organic checkbox with value from real form
  var organic_checked = parseInt(
    $('.js--search-bar-form input[name="organic"]').val()
  )
    ? 1
    : 0;
  $('.heading-with-side__side form input[name="organic"]').prop(
    "checked",
    organic_checked ? true : false
  );

  // On change update the real form with value from organic checkbox, and submit
  $(".heading-with-side__side form").on(
    "change",
    'input[type="checkbox"]',
    function (e) {
      organic_checked = this.checked ? 1 : 0;
      $('.js--search-bar-form input[name="organic"]').val(
        organic_checked
      );
      $(".js--search-bar-form").submit();
    }
  );

  // Custom file inputs
  $(".field-element--file").each(function () {
    var $input = $(this).find(".field-element--file__input"),
      $label = $(this).find(".field-element--file__button"),
      labelVal = $label.html();

    $input.on("change", function (e) {
      var fileName = "";

      if (this.files && this.files.length > 1) {
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      } else if (e.target.value) {
        fileName = e.target.value.split("\\").pop();
      }

      if (fileName) {
        $label.html(fileName);
      } else {
        $label.html(labelVal);
      }
    });
  });
});

onLoad(function() {
  $(".js--agree-to-tcs").on("click", function () {
    $('.mfp-bg, .mfp-wrap').remove();

    document.documentElement.style.overflow = '';
    document.body.style.height = '';
    document.body.style.overflow = '';

    $.get('ajax/agree_tos');
  });
});

onReady(function() {
  var $escort_elements = $(".field-element--js-name-autofill");

  $escort_elements.each(function () {
    var $optionList = $("<ul>").addClass("escort-option-list");
    var $textInput = $(this).find("input");

    var $hidden = null;
    var targetField = $textInput.attr('data-autofill-target');

    if (targetField) {
      $hidden = $(`input[name='${targetField}']`);

      // Multiedit hacks.
      if ($hidden.length == 0) {
        targetField = $textInput.attr('name').replace(/\[[^\]]+\]$/, `[${targetField}]`);
        $hidden = $(`input[name='${targetField}']`);

        console.log($textInput.attr('name'));
        console.log(targetField);
      }

      if ($hidden.length == 0) {
        console.error('Missing autofill target.');
        return;
      }
    }

    $(this).append(
      $("<div>").addClass("escort-find-options").append($optionList)
    );

    if ($hidden && $hidden.length) {
      $.get('ajax/lookup', { 'id': $hidden.val() })
      .then(function(result) {
          if (result.length > 0) {
              $textInput.val(result[0].name);
          }
      });
    }

    var onSearch = debounce(search, 200);
    var onBlur = debounce(() => $optionList.empty(), 200);

    $textInput.on("focus", onSearch);
    $textInput.on("input", onSearch);
    $textInput.on("blur", onBlur);

    function search() {
      var query = $textInput.val();

      if (query != "") {
        $.ajax({
          url: "/ajax/search",
          method: "POST",
          data: {
            q: query,
          },
        }).then(function (result) {
          $optionList.empty();

          if (!$textInput.is(':focus')) return;

          if (result.length > 0) {
            result.map(function (escort) {
              var $item = $("<li>")
                .addClass("escort-option-list__item")

              if ($hidden && $hidden.length) {
                $('<span>')
                  .text(escort.name)
                  .appendTo($item);

                $item.on('click', function() {
                  $hidden.val(escort.id);
                  $textInput.val(escort.name);
                });
              } else {
                $("<a>")
                  .attr("href", "/escort/" + escort.slug)
                  .text(escort.name)
                  .appendTo($item);
              }

              $optionList.append($item);
            });
          }
        });
      } else {
        $optionList.empty();
      }
    }
  });

  function debounce(fn, delay) {
    var timer = 0;

    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    }
  }
});

function toggleDates(disable) {
  var $dates = $("#js--date-from, #js--date-to");

  if (disable) {
    $dates.attr("disabled", "disabled");
    $dates.val("");
    $dates.trigger("change");
  } else {
    $dates.removeAttr("disabled");
  }
}

// function updateRegions(value) {
//   $("#js--dropdown-region").empty();

//   // A dummy default option with no-value.
//   var $option = $("<option>");
//   $option.text("City");
//   $option.val("");
//   $("#js--dropdown-region").append($option);

//   var $selected = null;

//   Object.keys(regions).map(function (key) {
//     // Filter by state, or everything if 'state' is a no-value.
//     if (!value || value == regions[key]["state"]) {
//       var $option = $("<option>");

//       $option.text(regions[key]["name"]);
//       $option.val(regions[key]["id"]);

//       // Selected by query params.
//       if (typeof region !== "undefined" && region == regions[key]["id"]) {
//         $selected = $option;
//       }

//       $("#js--dropdown-region").append($option);
//     }
//   });

//   // Not selected by query?
//   // Use the 'first' one (actually second because the first is a no-value).
//   if (!!value && $selected === null) {
//     $selected = $("#js--dropdown-region option").eq(1);
//   }

//   if ($selected !== null) {
//     $selected.attr("selected", "selected");
//   }
// }

function setAction() {
  var $form = $("#js--search-form");

  var user_type = $form.attr("user_type");

  var state = $("#js--dropdown-state option:selected")
    .text()
    .toLowerCase()
    .split(" ")
    .join("-");

  var region = $("#js--dropdown-region option:selected")
    .text()
    .toLowerCase()
    .split(" ")
    .join("-");

  $form.attr("action", [user_type, "search", state, region].join("/"));
}

function setStates(region_id) {
  var states = window.regions[region_id];

  if (!region_id || !states) {
    states = window.region_capitals;
  }

  var $region = $("#js--dropdown-region");
  $region.empty();

  $region.append($('<option/>', {
    class: 'dropdown-top',
    value: '',
    text: 'City',
  }));

  states.forEach(state => {
    $region.append($('<option/>', {
      value: state.id,
      text: state.name,
      selected: state.capital,
    }));
  });
}

onReady(function() {
  var $state = $("#js--dropdown-state");
  var $region = $("#js--dropdown-region");
  var $available = $("[type=checkbox][value=now_available]");

  $state.removeAttr('name');
  $region.removeAttr('name');

  $state.on("change", function () {
    setStates($(this).val());
    setAction();
  });

  $region.on("change", function () {
    setAction();
  });

  $available.on("change", function () {
    toggleDates(this.checked);
  });

  toggleDates($available.is(":checked"));
});


onReady(function() {
  $("#js--toggle-availability").on("change", function () {
    $.ajax("/ajax/toggle_availability").then(function (result) {
      $("#js--toggle-availability").prop("checked", result);
    });
  });

  // Favourite toggles
  $(document).on('click', '.js--favourite', function() {
    let params = {
      type: $(this).data('type'),
      id: $(this).data('id')
    };

    let url = "user/toggle_favourite?" + $.param(params);
    let $elem = $(this);
    let showImgClass = $(this).data('show-img-class') || false;

    $.get(url, function(data) {
      if (!data.success) {
        alert(data.message || 'Sorry, we encountered an error, please try again');
        return;
      }

      if (data.new_status) {
        $('.js--favourite-msg').html('Remove from Favourites');
        $('.js--follow-msg').html('Un-follow');
        if (showImgClass) $elem.addClass('remove-favourite-button');
      } else {
        $('.js--favourite-msg').html('Add to Favourites');
        $('.js--follow-msg').html('Follow');
        if (showImgClass) $elem.removeClass('remove-favourite-button');
      }
    })
    .fail(function(error) {
      alert('Sorry, we encountered an error, please try again');
    });
  });

});


onReady(function() {
  $('[data-ph-no]').on('click', function onClick(event) {
    event.preventDefault();

    const number = $(this).data('ph-no')
      .match(/../g)
      .map(c => String.fromCharCode(parseInt(c, 16)))
      .reverse()
      .join('');

    const link = 'sms://' + number + '?&body=Enquiry%20from%20Dakota%20Dice:%20';

    $(this)
      .text(number)
      .attr('href', link)
      .off('click', onClick);

    return false;
  });
});


/* -----------------------------
    Discreet mode
-------------------------------- */
function getDiscreetMode() {
  var isDiscreetMode = localStorage.getItem("discreetMode");
  return isDiscreetMode;
}

function setDiscreetMode(val) {
  localStorage.setItem("discreetMode", val);
}

function activateDiscreetMode() {
  $("html").addClass("discreet-mode-on");
  setDiscreetMode("y");
  toggleFeatureTileHover();
}

function deactivateDiscreetMode() {
  $("html").removeClass("discreet-mode-on");
  setDiscreetMode("n");
  toggleFeatureTileHover();
}


// Show a tab
function showTab($btn) {
  var $item;
  if (!$btn.parent().hasClass("highlight")) {
    $item = $btn.parent();
  } else {
    $item = $(
      '.tabs-list__item button[data-target="' +
        $btn.attr("data-target") +
        '"]'
    ).parent();
  }

  var $tabsList = $(".tabs-list");

  // First tab class
  if ($item.is(":first-child")) {
    $("html").addClass("tabs-first-item");
  } else {
    $("html").removeClass("tabs-first-item");
  }

  // Set tab button as active
  $tabsList.find(".tabs-list__item").removeClass("tabs-list__item--active");
  $item.addClass("tabs-list__item--active");

  // Set tab content as active
  $target = $('.tab[data-tab="' + $btn.attr("data-target") + '"]');
  $target.siblings(".tab").removeClass("tab--active");
  $target.addClass("tab--active");

  // Trigger resize for parallax update3
  if ($(window).width() > bp2) {
    $(window).trigger("resize").trigger("scroll");
  }

  // Scroll to top if mobile
  if ($(window).width() <= bp5) {
    window.scrollTo(0, 0);
  }

  // Add index
  $tabsList.attr("data-active-index", $item.index() + 1);
}

// Show the tab specified by the URL, or the first tab if nothing specified (this shouldn't ever happen)
function showDefaultTab() {
  var $def = $btns.filter(
    '[data-target="' + window.location.hash.substring(1) + '"]'
  );
  if ($def.length) {
    showTab($def);
  } else {
    showTab($btns.filter(":first"));
  }
}

// Article boxes
// Hover states
function articleBoxShow(e) {
  $(e.delegateTarget)
    .addClass("article-box__list__item--hover")
    .find(".article-box__content__hover")
    .stop()
    .slideDown(300);
}

function articleBoxHide(e) {
  $(e.delegateTarget)
    .removeClass("article-box__list__item--hover")
    .find(".article-box__content__hover")
    .stop()
    .slideUp(250);
}

function checkArticleBoxHover() {
  if ($(window).width() > bp2) {
    $(".article-box__list--hover-states .article-box__list__item")
      .off("mouseenter", articleBoxShow)
      .on("mouseenter", articleBoxShow);
    $(".article-box__list--hover-states .article-box__list__item")
      .off("mouseleave", articleBoxHide)
      .on("mouseleave", articleBoxHide);
  } else {
    $(".article-box__list--hover-states .article-box__list__item").off(
      "mouseenter",
      articleBoxShow
    );
    $(".article-box__list--hover-states .article-box__list__item").off(
      "mouseleave",
      articleBoxHide
    );
  }
}

function checkFeatureTileHover() {
  if ($(window).width() > bp2 && getDiscreetMode() != "y") {
    $(".feature-tile")
      .off("mouseenter")
      .off("mouseleave");
    $(".feature-tile")
      .on("mouseenter", featureTileShow)
      .on("mouseleave", featureTileHide);
  } else {
    if ($(window).width() > bp2) {
      // Use the desktop feature tile show function
      $(".feature-tile").each(function () {
        featureTileShow($(this));
      });
    } else {
      // On mobile and tablet just ensure the feature tile content isn't being forcibly hidden
      $(".feature-tile").off("mouseenter");
      $(".feature-tile").off("mouseleave");
      $(".feature-tile-content__hover").css({
        display: "",
        height: "",
        paddingTop: "",
        marginTop: "",
        paddingBottom: "",
        marginBottom: "",
      });
    }
  }
}

//Expose this function
window.checkFeatureTileHover = checkFeatureTileHover;

function featureTileShow(tileItem) {
  var $this = tileItem;
  if (tileItem.hasOwnProperty("delegateTarget")) {
    $this = $(tileItem.delegateTarget);
  } else {
    $this = $(tileItem);
  }
  $this
    .addClass("feature-tile-hover")
    .find(".feature-tile-content__hover")
    .stop()
    .slideDown(300);
}

function featureTileHide(tileItem) {
  var $this = tileItem;
  if (tileItem.hasOwnProperty("delegateTarget")) {
    $this = $(tileItem.delegateTarget);
  } else {
    $this = $(tileItem);
  }
  $this
    .removeClass("feature-tile-hover")
    .find(".feature-tile-content__hover")
    .stop()
    .slideUp(250);
}

function toggleFeatureTileHover() {
  if (getDiscreetMode() == "y") {
    $(".feature-tile").each(function () {
      featureTileShow($(this));
    });

    // disable hover
    $(".feature-tile").off("mouseenter");
    $(".feature-tile").off("mouseleave");
  } else {
    $(".feature-tile").each(function () {
      featureTileHide($(this));
    });
    // enable hover
    $(".feature-tile").on("mouseenter", featureTileShow);
    $(".feature-tile").on("mouseleave", featureTileHide);
  }
}

/**
 * Function for smooth scrolling to a given elements
 *
 * @param Object elem A valid jquery selector
 * @param int timeScroll The time in ms to spend scrolling
 */
function scrollUp(elem, timeScroll, offsetAdjust) {
  var offSet;

  if (typeof elem === "undefined" || !elem) {
    offSet = 0;
  } else {
    offSet = $("body").scrollTop() + elem.offset().top - headerHeight;
  }

  if (typeof offsetAdjust != "undefined" && offsetAdjust != 0) {
    offSet = parseInt(offSet) + parseInt(offsetAdjust);
  }

  if (typeof timeScroll === "undefined" || !timeScroll) timeScroll = 1000;

  $("body,html").animate(
    {
      scrollTop: offSet,
    },
    1000
  );
  return false;
}

}(); // eof
